import { defineMessages } from 'react-intl';

const scope = 'app.containers.shared.NotesManagement';

export default defineMessages({
    retryBtn: {
        id: `${scope}.retryBtn`,
        defaultMessage: 'Retry',
    },
    loadingMessage: {
        id: `${scope}.loadingMessage`,
        defaultMessage: 'Fetching your data...',
    },
    errorDescription: {
        id: `${scope}.errorDescription`,
        defaultMessage:
            'Sorry, there was an error loading the rates for the selected rate band. Please try again later.',
    },
    // Actions
    addNewBtn: {
        id: `${scope}.actions.addNewBtn`,
        defaultMessage: 'Add new',
    },
    refreshTooltip: {
        id: `${scope}.actions.refreshTooltip`,
        defaultMessage: 'Refresh',
    },
    // Table
    stayDateColumnLabel: {
        id: `${scope}.displayTable.stayDateColumnLabel`,
        defaultMessage: 'Stay Date',
    },
    noteColumnLabel: {
        id: `${scope}.displayTable.noteColumnLabel`,
        defaultMessage: 'Note',
    },
    priorityColumnLabel: {
        id: `${scope}.displayTable.priorityColumnLabel`,
        defaultMessage: 'Priority',
    },
    // Modal Common
    cancelBtn: {
        id: `${scope}.modal.cancelBtn`,
        defaultMessage: 'Close',
    },
    actionErrorMessage: {
        id: `${scope}.modal.actionErrorMessage`,
        defaultMessage: 'Sorry, there was an error performing this action. Please try again later.',
    },
    // Update modal
    updateModalDisclaimer: {
        id: `${scope}.modal.updateModalDisclaimer`,
        defaultMessage: 'Any existing notes in the date range you select will be overwritten by this note.',
    },
    updateModalTitle: {
        id: `${scope}.modal.updateModalTitle`,
        defaultMessage: 'Modify Note',
    },
    applyBtn: {
        id: `${scope}.modal.applyBtn`,
        defaultMessage: 'Apply',
    },
    dateRangeLabel: {
        id: `${scope}.modal.form.dateRange.label`,
        defaultMessage: 'Date range',
    },
    noteLabel: {
        id: `${scope}.modal.form.notes.label`,
        defaultMessage: 'Note',
    },
    // Delete
    confirmDeletionText: {
        id: `${scope}.delete.confirmDeletionText`,
        defaultMessage: 'Are you sure you want to delete this note?',
    },
    confirmOk: {
        id: `${scope}.delete.confirmOk`,
        defaultMessage: 'OK- delete note',
    },
    confirmCancel: {
        id: `${scope}.delete.confirmCancel`,
        defaultMessage: 'Cancel',
    },
    deleteSuccessMessage: {
        id: `${scope}.delete.deleteSuccessMessage`,
        defaultMessage: 'Note successfully deleted',
    },
    deleteErrorMessage: {
        id: `${scope}.delete.deleteErrorMessage`,
        defaultMessage: 'Error deleting note',
    },
});
